import { render, staticRenderFns } from "./SpadD.vue?vue&type=template&id=8644075a"
import script from "./SpadD.vue?vue&type=script&lang=js"
export * from "./SpadD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports